// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pour les espaces vides qui maintiennent la structure de la grille */
.placeholder-group {
  min-height: 1px;
}

.radio-options {
  margin-top: 0.5rem;
}

.date-input {
  width: 100%;
}

/* Styles pour le mode consultation */
.view-mode {
  padding: 0;
}

.view-mode .form-group {
  margin-bottom: 2rem;
}

.view-mode label {
  font-weight: 600;
  display: block;
  margin-bottom: 0.5rem;
  color: #2C3948;
}

.step-container .form-subtitle {
  font-size: 1.2rem;
  color: #6B7280;
  font-style: italic;
  margin-left: 0.5rem;
}

.radio-options {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
}

.radio-options label {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  cursor: pointer;
}

.radio-options input[type="radio"] {
  width: 1.6rem;
  height: 1.6rem;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/composants/FormulaireAdministratif/FormulaireAdministratif.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;AACX","sourcesContent":["/* Pour les espaces vides qui maintiennent la structure de la grille */\n.placeholder-group {\n  min-height: 1px;\n}\n\n.radio-options {\n  margin-top: 0.5rem;\n}\n\n.date-input {\n  width: 100%;\n}\n\n/* Styles pour le mode consultation */\n.view-mode {\n  padding: 0;\n}\n\n.view-mode .form-group {\n  margin-bottom: 2rem;\n}\n\n.view-mode label {\n  font-weight: 600;\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #2C3948;\n}\n\n.step-container .form-subtitle {\n  font-size: 1.2rem;\n  color: #6B7280;\n  font-style: italic;\n  margin-left: 0.5rem;\n}\n\n.radio-options {\n  display: flex;\n  gap: 2rem;\n  margin-top: 1rem;\n}\n\n.radio-options label {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  cursor: pointer;\n}\n\n.radio-options input[type=\"radio\"] {\n  width: 1.6rem;\n  height: 1.6rem;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
